/** @jsxImportSource @emotion/react */
import { Rule } from "../../../service/api-response/DeliveryRule";
import { DeliveryRuleWrapper } from "./DeliveryRuleWrapper";
import { css } from "@emotion/react";

type Props = {
  fields: Rule[];
  remove: (index: number) => void;
};

const rulesWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const DeliveryRules = ({ fields, remove }: Props) => {
  return (
    <div css={rulesWrapper}>
      {fields.map((field, index) => (
        <DeliveryRuleWrapper key={field.id} remove={remove} index={index} />
      ))}
    </div>
  );
};
